export default __webpack_public_path__ + "static/wifi_b.a12c7c2b7f9cafed55aed1b2061905bc.png";